// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/scim/scim.actions.go

export const LIST_USERS = "mondoo.scim.UserProvisioning.ListUsers";
